import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AvatarModule } from '../avatar/avatar.module';
import { AvatarSidebarCellComponent } from './avatar-sidebar-cell.component';

@NgModule({
  declarations: [AvatarSidebarCellComponent],
  imports: [CommonModule, AvatarModule],
  exports: [AvatarSidebarCellComponent],
})
export class AvatarSidebarCellModule {}
